import { Icon } from "@iconify/react";
import { useTranslation } from "react-i18next";
import "./style.css";
import CheckBox from "src/component/CheckBox";
import { WaitingForPackingRequest } from "src/types/Requests/waitingPackingRequests";

interface SelectedActionsBarProps {
    selectedCount: number;
    onClear: () => void;
    onProcess: () => void;
    items: WaitingForPackingRequest[];
    handleToggleSelectAll: (items: WaitingForPackingRequest[]) => void;
    isAllSelected: (items: WaitingForPackingRequest[]) => boolean;
}

const SelectedActionsBar = ({
    selectedCount,
    onClear,
    onProcess,
    items,
    handleToggleSelectAll,
    isAllSelected,
}: SelectedActionsBarProps) => {
    const { t } = useTranslation();

    return (
        <div className="waiting-packing-actions-bar">
            <div className="actions-bar-content">
                <div className="selection-section">
                    <CheckBox
                        label="selectAll"
                        setValue={() =>
                            handleToggleSelectAll(items)
                        }
                        value={isAllSelected(items)}
                        className="tableBulkActionCheckBox d-flex flex-row-reverse align-items-center"
                    />
                </div>

                <div className="actions-bar-info">
                    <div className="selection-badge">
                        <Icon
                            icon="mdi:check-circle"
                            className="selection-icon"
                        />

                        <span className="selection-count">
                            {selectedCount}
                        </span>

                        <span className="selection-text">
                            {t("selected-requests")}
                        </span>
                    </div>
                </div>


                <div className="actions-bar-buttons">
                    <button
                        className="action-btn-clear"
                        onClick={onClear}
                    >
                        <Icon icon="mdi:close" />
                        {t("cancel")}
                    </button>

                    <button
                        className="action-btn-process"
                        onClick={onProcess}
                        disabled={selectedCount === 0}
                    >
                        <Icon icon="mdi:check-all" />
                        {t("setRequestAsPacked")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SelectedActionsBar;